// import { FirebaseDataService } from "../../services/firebase-data.service";
import { getDataFromMongoDb } from "../../services/mongod.data";

// const firebaseDataService = new FirebaseDataService();

// Helper function to compare numbers for sorting
function compareNumbers(a, b) {
  return a - b;
}

// Helper function to clean table data
function cleanTableData(fbdbYear, fbdbMonthsJson, reportTopK = 8) {
  var graphOptions = null;
  var tableDataRaw = {};
  var labelArray = null;
  var jsonData = [];
  var valcol_delimit = null;
  var key_cols = null;
  var val_cols = [];
  var valcols_dict = {};
  var all_YMDs = [];

  Object.keys(fbdbMonthsJson).forEach(month => {
    Object.keys(fbdbMonthsJson[month]).forEach(week => {
      var tableDataWeek = JSON.parse(fbdbMonthsJson[month][week]["table_data"]);
      var elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
      var elemYMD_str = [fbdbYear, month, week].join('/');
      tableDataWeek.forEach(prop_keyval => {
        var prop_key = prop_keyval["prop_key"];
        var prop_val = prop_keyval["prop_value"];
        if (tableDataRaw.hasOwnProperty(prop_key)) {
          tableDataRaw[prop_key].push({ val: prop_val, YMD: elemYMD_tag });
        } else {
          tableDataRaw[prop_key] = [{ val: prop_val, YMD: elemYMD_tag }];
        }
      });
      valcol_delimit = fbdbMonthsJson[month][week]["col_delimiter"];
      var key_colsJSON = fbdbMonthsJson[month][week]["key_columns"];
      key_cols = Object.values(key_colsJSON);
      valcols_dict[elemYMD_tag] = elemYMD_str;
    });
  });

  Object.keys(valcols_dict).sort(compareNumbers).forEach(YMD => {
    val_cols.push(valcols_dict[YMD]);
    all_YMDs.push(YMD);
  });
  labelArray = key_cols.concat(val_cols.slice(-reportTopK));

  Object.keys(tableDataRaw).forEach(prop_key => {
    var item = {};
    var itemXweek = {};
    tableDataRaw[prop_key].forEach(elementTup => {
      itemXweek[elementTup.YMD] = elementTup.val;
    });

    all_YMDs.forEach(YMD => {
      if (!itemXweek.hasOwnProperty(YMD)) {
        itemXweek[YMD] = "";
      }
    });

    var sorted_propval = [];
    Object.keys(itemXweek).sort(compareNumbers).forEach(YMD => {
      sorted_propval.push(itemXweek[YMD]);
    });
    var row_val = prop_key.split(valcol_delimit).concat(sorted_propval.slice(-reportTopK));
    labelArray.map(function (key, indx) {
      item[key] = row_val[indx];
    });
    jsonData.push(item);
  });
  return [jsonData, labelArray];
}

// Helper function to clean unique BnDev data
function cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = "barchart") {
  var sortingArray = []
  var tempUnsortedJson = {}
  var graphOptions = null;
  var jsonData = null;
  var varArray1 = [];
  var varArray2 = [];
  var varArray3 = [];
  var varArray4 = [];
  var varArray5 = [];
  var varArray6 = [];
  var varArray7 = [];
  var varArray8 = [];
  var varArray9 = [];
  var varArray10 = [];
  var varArray11 = [];
  var varArray12 = [];
  var varLabel1 = "Variable 1";
  var varLabel2 = "Variable 2";
  var varLabel3 = null;
  var varLabel4 = null;
  var varLabel5 = null;
  var varLabel6 = null;
  var varLabel7 = null;
  var varLabel8 = null;
  var varLabel9 = null;
  var varLabel10 = null;
  var varLabel11 = null;
  var varLabel12 = null;
  var labelArray = [];
  var dataJson;
  var utm_uqiue_list = []

  Object.keys(fbdbMonthsJson).forEach(month => {
    if ((fbdbMonthsJson[month]) !== null) {
      Object.keys(fbdbMonthsJson[month]).forEach(week => {
        jsonData = fbdbMonthsJson[month][week];

        if (jsonData.hasOwnProperty("barchart_var1")) {
          varLabel1 = jsonData["barchart_var1"][0];
        }
        if (jsonData.hasOwnProperty("barchart_var2")) {
          varLabel2 = jsonData["barchart_var2"][0];
        }
        if (jsonData.hasOwnProperty("barchart_var3")) {
          varLabel3 = jsonData["barchart_var3"][0];
        }
        if (jsonData.hasOwnProperty("barchart_var5")) {
          varLabel4 = jsonData["barchart_var4"][0];
          varLabel5 = jsonData["barchart_var5"][0];
        }
        if (jsonData.hasOwnProperty("barchart_var10")) {
          varLabel4 = jsonData["barchart_var4"][0];
          varLabel5 = jsonData["barchart_var5"][0];
          varLabel6 = jsonData["barchart_var6"][0];
          varLabel7 = jsonData["barchart_var7"][0];
          varLabel8 = jsonData["barchart_var8"][0];
          varLabel9 = jsonData["barchart_var9"][0];
          varLabel10 = jsonData["barchart_var10"][0];
          varLabel11 = jsonData["barchart_var11"][0];
          varLabel12 = jsonData.hasOwnProperty("barchart_var12") ? jsonData["barchart_var12"][0] : null;
        }

        var barchart_var3 = jsonData.hasOwnProperty("barchart_var3") ? jsonData["barchart_var3"][1] : null;
        var barchart_var4 = jsonData.hasOwnProperty("barchart_var4") ? jsonData["barchart_var4"][1] : null;
        var barchart_var5 = jsonData.hasOwnProperty("barchart_var5") ? jsonData["barchart_var5"][1] : null;
        var barchart_var6 = jsonData.hasOwnProperty("barchart_var6") ? jsonData["barchart_var6"][1] : null;
        var barchart_var7 = jsonData.hasOwnProperty("barchart_var7") ? jsonData["barchart_var7"][1] : null;
        var barchart_var8 = jsonData.hasOwnProperty("barchart_var8") ? jsonData["barchart_var8"][1] : null;
        var barchart_var9 = jsonData.hasOwnProperty("barchart_var9") ? jsonData["barchart_var9"][1] : null;
        var barchart_var10 = jsonData.hasOwnProperty("barchart_var10") ? jsonData["barchart_var10"][1] : null;
        var barchart_var11 = jsonData.hasOwnProperty("barchart_var11") ? jsonData["barchart_var11"][1] : null;
        var barchart_var12 = jsonData.hasOwnProperty("barchart_var12") ? jsonData["barchart_var12"][1] : null;
        var elemYMD_tag = parseInt(month) * 100;

        if (chartType === "noncadenceBarchart") {
          tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
          jsonData["barchart_var2"][1], [month, week].join(''), barchart_var3]
        }

        if (chartType === "noncadenceUTMchart") {
          if (!utm_uqiue_list.includes([week].join(''))) {
            tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
            jsonData["barchart_var2"][1], [week].join(''), barchart_var3]
            utm_uqiue_list = [...utm_uqiue_list, [week].join('')]
          } else {
            return;
          }
        }
        if (chartType === "barchart") {
          elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
          if (jsonData.hasOwnProperty("barchart_var2")) {
            tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
            jsonData["barchart_var2"][1], [fbdbYear, month, week].join('/'), barchart_var3]
          }
        }
        if (chartType === "socialCounts") {
          elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
          tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
          jsonData["barchart_var2"][1], [fbdbYear, month, week].join('/'), barchart_var3, barchart_var4,
            barchart_var5, barchart_var6, barchart_var7, barchart_var8, barchart_var9, barchart_var10, barchart_var11, barchart_var12]
        }
        if (chartType === "funnelLeakage") {
          elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
          tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
          jsonData["barchart_var2"][1], [fbdbYear, month, week].join('/'), barchart_var3, barchart_var4, barchart_var5]
        }
        sortingArray.push(elemYMD_tag)
      });
    }
  });

  sortingArray.sort(compareNumbers).forEach(YMD => {
    if (tempUnsortedJson[YMD] !== undefined) {
      varArray1.push(tempUnsortedJson[YMD][0]);
      varArray2.push(tempUnsortedJson[YMD][1]);

      if (chartType === 'socialCounts') {
        varArray3.push(tempUnsortedJson[YMD][3]);
        varArray4.push(tempUnsortedJson[YMD][4]);
        varArray5.push(tempUnsortedJson[YMD][5]);
        varArray6.push(tempUnsortedJson[YMD][6]);
        varArray7.push(tempUnsortedJson[YMD][7]);
        varArray8.push(tempUnsortedJson[YMD][8]);
        varArray9.push(tempUnsortedJson[YMD][9]);
        varArray10.push(tempUnsortedJson[YMD][10]);
        varArray11.push(tempUnsortedJson[YMD][11]);
        varArray12.push(tempUnsortedJson[YMD][12]);
      }
      else if (chartType === 'funnelLeakage') {
        varArray3.push(tempUnsortedJson[YMD][3]);
        varArray4.push(tempUnsortedJson[YMD][4]);
        varArray5.push(tempUnsortedJson[YMD][5]);
      }
      else if (tempUnsortedJson[YMD][3] != null || chartType === "barchart") {
        varArray3.push(tempUnsortedJson[YMD][3]);
      }

      labelArray.push(tempUnsortedJson[YMD][2]);
    }
  });

  if (chartType === 'socialCounts') {
    dataJson = [
      { data: varArray1, label: varLabel1 },
      { data: varArray2, label: varLabel2 },
      { data: varArray3, label: varLabel3 },
      { data: varArray4, label: varLabel4 },
      { data: varArray5, label: varLabel5 },
      { data: varArray6, label: varLabel6 },
      { data: varArray7, label: varLabel7 },
      { data: varArray8, label: varLabel8 },
      { data: varArray9, label: varLabel9 },
      { data: varArray10, label: varLabel10 },
      { data: varArray11, label: varLabel11 },
      { data: varArray12, label: varLabel12 },
    ]
  }
  else if (chartType === 'funnelLeakage') {
    dataJson = [
      { data: varArray1, label: varLabel1 },
      { data: varArray2, label: varLabel2 },
      { data: varArray3, label: varLabel3 },
      { data: varArray4, label: varLabel4 },
      { data: varArray5, label: varLabel5 },
    ]
  }
  else {
    dataJson = (varLabel3 != null) ? [
      { data: varArray1, label: varLabel1 },
      { data: varArray2, label: varLabel2 },
      { data: varArray3, label: varLabel3 }
    ] : [
      { data: varArray1, label: varLabel1 },
      { data: varArray2, label: varLabel2 }
    ];
  }
  return [dataJson, labelArray];
}

// Complete implementation of getStats
function getStats(statsObj, user, graph, chartType = "barchart") {
  return new Promise(async (resolve, reject) => {
    try {
      let week_label_array = [];
      let dataZero = [];
      let dataOne = [];
      let dataTwo = [];
      let dataThree = [];
      let dataFour = [];
      let dataFive = [];
      let dataSix = [];
      let dataSeven = [];
      let dataEight = [];
      let dataNine = [];
      let dataTen = [];
      let dataEleven = []
      let dataZerolabel, dataOnelabel, dataTwolabel, dataThreelabel, dataFourlabel, dataFivelabel
      let dataSixlabel, dataSevenlabel, dataEightlabel, dataNinelabel, dataTenlabel, dataElevenlabel
      let tableChartData = {}
      let key
      let value
      let url_as_key = false;
      const dataMap = {};
      var dataJson = null;
      var labelArray = null;
      var grapLabel = null;
      var weeklyTotal = [];

      const mongoResponse = await getDataFromMongoDb(user, graph);
      
      if (mongoResponse && mongoResponse.data) {
        console.log("Fetched persona data mongo:", mongoResponse);
        const dataArray = Object.entries(mongoResponse.data)
        if (!dataArray.length) {
          resolve([dataMap]);
          return;
        }
        console.log("Fetched persona data mongo:", mongoResponse.data);

        dataArray.forEach(([key, item]) => {
          if (key === 'graph-options') {
            grapLabel = JSON.parse(JSON.stringify(item));
          }
          else if (key === 'graph-backup') {
            // Do nothing, Don't Remove it 
          }
          else {
            var fbdbMonthsJson = JSON.parse(JSON.stringify(item));
            var fbdbYear = key;
            if (chartType === "barchart") {
              [dataJson, labelArray] = cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson);

            } else if (chartType === "tablechart") {
              [dataJson, labelArray] = cleanTableData(fbdbYear, fbdbMonthsJson);

            } else if (chartType === "noncadenceBarchart") {
              [dataJson, labelArray] = cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType);
              weeklyTotal.push(dataJson[0]?.data[0]);
            } else if (chartType === "noncadenceUTMchart") {
              [dataJson, labelArray] = cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType);

            } else if (chartType === "socialCounts" || chartType === "funnelLeakage") {
              [dataJson, labelArray] = cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType);
            }

            // update each year data in own buckets
            if (chartType === 'noncadenceBarchart' || chartType === 'noncadenceUTMchart') {
              dataMap[key] = [dataJson, labelArray, grapLabel, weeklyTotal];
            }

            else if (key !== 'graph-options' && chartType === 'barchart') {
              week_label_array = [...week_label_array, ...labelArray]
              dataZero = [...dataZero, ...dataJson[0].data];
              dataZerolabel = dataJson[0].label;
              dataOne = [...dataOne, ...dataJson[1].data];
              dataOnelabel = dataJson[1].label;

              if (dataJson.length > 2) {
                dataTwo = [...dataTwo, ...dataJson[2].data];
                dataTwolabel = dataJson[2].label;
              }
            }

            else if (key !== 'graph-options' && chartType === 'tablechart') {
              week_label_array = [...week_label_array, ...labelArray]
              week_label_array = week_label_array.filter((item, index) => week_label_array.indexOf(item) === index);
              if (dataJson[0] &&'URL' in dataJson[0]) {
                url_as_key = true;
                dataJson.map(item => {
                  const { URL, ...Rest } = item;
                  tableChartData[URL] = tableChartData[URL] ? { ...tableChartData[URL], ...{ ...Rest } } : Rest;
                })
              } else {
                dataJson.map(item => {
                  const { Browser, "Operating System": OS, Device, ...Rest } = item;
                  key = [Browser, OS, Device]
                  tableChartData[key] = tableChartData[key] ? { ...tableChartData[key], ...{ ...Rest } } : Rest;
                })
              }
            }
            else if (key !== 'graph-options' && chartType === 'socialCounts') {
              week_label_array = [...week_label_array, ...labelArray]
              dataZero = [...dataZero, ...dataJson[0].data];
              dataZerolabel = dataJson[0].label;
              dataOne = [...dataOne, ...dataJson[1].data];
              dataOnelabel = dataJson[1].label;
              dataTwo = [...dataTwo, ...dataJson[2].data];
              dataTwolabel = dataJson[2].label;
              dataThree = [...dataThree, ...dataJson[3].data];
              dataThreelabel = dataJson[3].label;
              dataFour = [...dataFour, ...dataJson[4].data];
              dataFourlabel = dataJson[4].label;
              dataFive = [...dataFive, ...dataJson[5].data];
              dataFivelabel = dataJson[5].label;
              dataSix = [...dataSix, ...dataJson[6].data];
              dataSixlabel = dataJson[6].label;
              dataSeven = [...dataSeven, ...dataJson[7].data];
              dataSevenlabel = dataJson[7].label;
              dataEight = [...dataEight, ...dataJson[8].data];
              dataEightlabel = dataJson[8].label;
              dataNine = [...dataNine, ...dataJson[9].data];
              dataNinelabel = dataJson[9].label;
              dataTen = [...dataTen, ...dataJson[10].data];
              dataTenlabel = dataJson[10].label;
              dataEleven = [...dataEleven, ...dataJson[11].data];
              dataElevenlabel = dataJson[11].label;
            }
            else if (key !== 'graph-options' && chartType === 'funnelLeakage') {
              week_label_array = [...week_label_array, ...labelArray]
              dataZero = [...dataZero, ...dataJson[0].data];
              dataZerolabel = dataJson[0].label;
              dataOne = [...dataOne, ...dataJson[1].data];
              dataOnelabel = dataJson[1].label;
              dataTwo = [...dataTwo, ...dataJson[2].data];
              dataTwolabel = dataJson[2].label;
              dataThree = [...dataThree, ...dataJson[3].data];
              dataThreelabel = dataJson[3].label;
              dataFour = [...dataFour, ...dataJson[4].data];
              dataFourlabel = dataJson[4].label;
            }
          }
        })

        // send graphData to calling component.ts 
        if (chartType === 'noncadenceBarchart' || chartType === 'noncadenceUTMchart') {
          resolve([dataMap]);
        }
        else if (chartType === 'barchart') {
          let dataZeroObj = { "data": dataZero, "label": dataZerolabel }
          let dataOneObj = { "data": dataOne, "label": dataOnelabel }
          let dataTwoObj = { "data": dataTwo, "label": dataTwolabel }
          let newDataJSon = [dataZeroObj, dataOneObj]

          if (dataJson && dataJson.length === 3) {
            newDataJSon = [...newDataJSon, dataTwoObj]
          }
          resolve([newDataJSon, week_label_array, grapLabel, weeklyTotal]);
        }
        else if (chartType === 'tablechart') {
          let FinalTableData = [];
          if (url_as_key) {
            for (let key in tableChartData) {
              const [URL] = key.split(',');
              let tempObj = { 'URL': URL, ...tableChartData[URL] };
              FinalTableData.push(tempObj);
            }
          } else {
            for (let key in tableChartData) {
              const [Browser, OS, Device] = key.split(',');
              let tempObj = { 'Browser': Browser, 'Operating System': OS, 'Device': Device, ...tableChartData[key] };
              FinalTableData.push(tempObj);
            }
          }

          resolve([FinalTableData, week_label_array, grapLabel, weeklyTotal]);
        }
        else if (chartType === 'socialCounts') {
          let dataZeroObj = { "data": dataZero, "label": dataZerolabel }
          let dataOneObj = { "data": dataOne, "label": dataOnelabel }
          let dataTwoObj = { "data": dataTwo, "label": dataTwolabel }
          let dataThreeObj = { "data": dataThree, "label": dataThreelabel }
          let dataFourObj = { "data": dataFour, "label": dataFourlabel }
          let dataFiveObj = { "data": dataFive, "label": dataFivelabel }
          let dataSixObj = { "data": dataSix, "label": dataSixlabel }
          let dataSevenObj = { "data": dataSeven, "label": dataSevenlabel }
          let dataEightObj = { "data": dataEight, "label": dataEightlabel }
          let dataNineObj = { "data": dataNine, "label": dataNinelabel }
          let dataTenObj = { "data": dataTen, "label": dataTenlabel }
          let dataElevenObj = { "data": dataEleven, "label": dataElevenlabel }

          let newDataJSon = [dataZeroObj, dataOneObj, dataTwoObj, dataThreeObj, dataFourObj, dataFiveObj,
            dataSixObj, dataSevenObj, dataEightObj, dataNineObj, dataTenObj, dataElevenObj]

          resolve([newDataJSon, week_label_array, grapLabel, weeklyTotal]);
        }
        else if (chartType === 'funnelLeakage') {
          let dataZeroObj = { "data": dataZero, "label": dataZerolabel }
          let dataOneObj = { "data": dataOne, "label": dataOnelabel }
          let dataTwoObj = { "data": dataTwo, "label": dataTwolabel }
          let dataThreeObj = { "data": dataThree, "label": dataThreelabel }
          let dataFourObj = { "data": dataFour, "label": dataFourlabel }

          let newDataJSon = [dataZeroObj, dataOneObj, dataTwoObj, dataThreeObj, dataFourObj]
          resolve([newDataJSon, week_label_array, grapLabel, weeklyTotal]);
        }

      } else {
        resolve([]);
      }
    } catch (error) {
      console.error("Error fetching data from MongoDB:", error);
      reject(error);
    }
  });
}

export function fetchGraphPersona(statsObj, user, graph) {
  return new Promise(async (resolve, reject) => {
    try {
      // Original FirebaseDataService implementation (commented out)
      // firebaseDataService.getStats(statsObj, user, graph).subscribe((data) => {
      //   resolve({ data });
      // });
      
      // New direct implementation
      const data = await getStats(statsObj, user, graph);
      resolve({ data });
    } catch (error) {
      reject(error);
    }
  });
}
